import { mdPromptPlugin } from './plugin.js';

export { mdPromptPlugin };
export default mdPromptPlugin;